import React from 'react';
import GameScoreBoard from '../GameScoreBoard.js';
import {_GPY,__GPYPost} from '../../../env.js'

import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyTime from '../lib/GpyTime.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyScoreField from '../lib/GpyScoreField.js';
import GpyTeamSelect from '../lib/GpyTeamSelect.js'
import GpyGameLog from '../lib/GpyGameLog.js';
import GpyTeamList from '../lib/GpyTeamList.js';

import WaitCube from '../../../WaitCube';

import ScoreboardGameSelector from '../lib/ScoreboardGameSelector.js';
import ScoreboardDisplayPanel from '../lib/ScoreboardDisplayPanel.js';
import ScoreboardFreeTextPanel from '../lib/ScoreboardFreeTextPanel.js';
import ScoreboardTeamScorePanel from '../lib/ScoreboardTeamScorePanel.js';
import ScoreboardAdvertisementTournament from '../lib/ScoreboardAdvertisementTournament.js';
import ScoreboardTeamDefaultButtons from '../lib/ScoreboardTeamDefaultButtons.js';
import ScoreboardPeriods from '../lib/ScoreboardPeriods.js';
import ScoreboardClock from '../lib/ScoreboardClock.js';
import ScoreboardStats from '../lib/ScoreboardStats.js';


class SBBasketball extends GameScoreBoard {

		constructor(props) {
			super(props);
			var s = super.getGPYState("Basketball");
			s.NAME = "Basketball";
			this.state = s;
			s.currentSet = 0;
			s.defaultDataStore = {
			 	set: [
					{home_score:0,guest_score:0},
					{home_score:0,guest_score:0},
					{home_score:0,guest_score:0},
					{home_score:0,guest_score:0},
					{home_score:0,guest_score:0},
				],
			}

			s.mainClockDependenciesClocks=[
			   {clock : this.getName()+"_offense", button : this.getName()+'_button_offense_home_24'},
				 {clock : this.getName()+"_offense", button : this.getName()+'_button_offense_guest_24'},
				 {clock : this.getName()+"_offense", button : this.getName()+'_button_offense_home_14'},
				 {clock : this.getName()+"_offense", button : this.getName()+'_button_offense_guest_14'},
		  ];
		}

		componentDidMount() {
			super.componentDidMount();
			super.loadUserConfig().then((res)=>{
				super.getGamesStates();
				super.getGames();
			});
		}
		componentWillUnmount() {
			 super.componentWillUnmount();
		}
		getMainClock() {
	 		return super.getMainClock();
		}
		togglePlay(method) {
			return super.togglePlay(method);
		}
		adjustTimers(millis,callback) {
			return super.adjustTimers(millis,callback) ;
		}
		initDataStore(id) {
			var ds = this.state.dataStore;
			this.setState({dataStore:ds});
		}
		getCurrentGuestScore() {
			var tmpGuestScore = 0;
			for( var p = 1 ; p< this.state.dataStore.set.length ; p++ ) {
			 tmpGuestScore += this.state.dataStore.set[p].guest_score;
			}
			return tmpGuestScore;
	  }
	  getCurrentHomeScore() {
			var tmpHomeScore = 0;
			for( var p = 1 ; p< this.state.dataStore.set.length ; p++ ) {
			 tmpHomeScore += this.state.dataStore.set[p].home_score;
			}
			return tmpHomeScore;
	  }

		render () {
			const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
			if(!this.state.defaultValuesLoaded) {
				return (<WaitCube/>);
			}

		  return (
				<>
						<GpyTime stateName={this.getName()+"_offense"} hidden="true" countdown="true" scoreboard={this}/>

						<ScoreboardGameSelector scoreboard={this} beta={true}/>

		{this.state.currentGame.id > 0 ?

						<div className="row p-3">
						 <div className="col" style={{maxWidth:this.state.displayWidth+"px"}}>

									<ScoreboardDisplayPanel scoreboard={this} />

									<div className="row"><div className="col-12">
											<ScoreboardTeamScorePanel scoreboard={this} scoreValues={[1,2,3]}
											needPeriodIndex={true}
											onChangeHomeScore={(score,callback)=>{
												var ds = this.state.dataStore;
												ds.set[this.state.currentPeriodIndex].home_score = score;
												this.setState({dataStore:ds},()=>{
													super.storeData();
													callback();
												});
											}}
											onChangeGuestScore={(score,callback)=>{
												var ds = this.state.dataStore;
												ds.set[this.state.currentPeriodIndex].guest_score = score;
												this.setState({dataStore:ds},()=>{
													super.storeData();
													callback();
												});
											}}
											getUpdateDependenciesComponents={()=>{
												return [
													this.getName() + "_button_vs_and_score_full",
													this.getName() + "_button_vs_and_score_mini",
													this.getName() + "_button_full_statistics"
												];
											}}/>


<div className="row">
											<div className="col-4 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_foul_home_button')}
												 	 onInit={() => {return {}}}
												 	 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {

 														var m = this.getMainClock().getSecond();
 														var minF = (m/1000) / 60 ;
 														var min = Math.floor(minF) ;
 														var sec = Math.floor((minF-min)*60);

 														var formatMin = ('00'+min).slice(-2);
 														var formatSec = ('00'+sec).slice(-2);
														var p = {id:-1, firstName:"", lastName: this.state.currentGame.teamMap.HOME_TEAM.name, numOrPos:"", playerId:"", vsRole:"HOME_TEAM_PLAYER", profileImage: "default_avatar.png"};
 														return {visible: true,
 															playerName : _GPY.toPlayerName(p),
 															player:p,
 															team: super.getTeamByPlayer(p),
 															time: this.getMainClock().getSecond(),
 															minute: formatMin,
 															second: formatSec,
 														}}}
												 		 scoreboard={this}
												 		 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
												 	 stateName={this.getName()+"_button_foul_home_button"}
												 	 autoexpirytime="10"/>
											</div>

											<div className="col-4 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_foul_player_button')}
													 onInit={() => {return {}}}
													 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {

 													 var m = this.getMainClock().getSecond();
 													 var minF = (m/1000) / 60 ;
 													 var min = Math.floor(minF) ;
 													 var sec = Math.floor((minF-min)*60);

 													 var formatMin = ('00'+min).slice(-2);
 													 var formatSec = ('00'+sec).slice(-2);
 													 var p = this.state.selectedPlayers[Object.keys(this.state.selectedPlayers)[0]];
 													 return {visible: true,
 														 playerName : _GPY.toPlayerName(p),
 														 player:p,
 														 team: super.getTeamByPlayer(p),
 														 time: this.getMainClock().getSecond(),
 														 minute: formatMin,
 														 second: formatSec,
 													 }}}
														 scoreboard={this}
														 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
													 stateName={this.getName()+"_button_foul_player_button"}
													 autoexpirytime="10"/>
											</div>


											<div className="col-4 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_foul_guest_button')}
												 	 onInit={() => {return {}}}
												 	 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {

 													 var m = this.getMainClock().getSecond();
 													 var minF = (m/1000) / 60 ;
 													 var min = Math.floor(minF) ;
 													 var sec = Math.floor((minF-min)*60);

 													 var formatMin = ('00'+min).slice(-2);
 													 var formatSec = ('00'+sec).slice(-2);
 													 var p = {id:-1, firstName:"", lastName: this.state.currentGame.teamMap.HOME_TEAM.name, numOrPos:"", playerId:"", vsRole:"GUEST_TEAM_PLAYER", profileImage: "default_avatar.png"};
 													 return {visible: true,
 														 playerName : _GPY.toPlayerName(p),
 														 player:p,
 														 team: super.getTeamByPlayer(p),
 														 time: this.getMainClock().getSecond(),
 														 minute: formatMin,
 														 second: formatSec,
 													 }}}
												 		 scoreboard={this}
												 		 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
												 	 stateName={this.getName()+"_button_foul_guest_button"}
												 	 autoexpirytime="10"/>
											</div>

</div>


<div className="row">
											<div className="col-3 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_offense_home_24_title')}
												 	 onInit={() => {return {}}}
												 	 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {
															 var excludes = [this.getName()+"_button_offense_guest_24",this.getName()+"_button_offense_guest_14",this.getName()+"_button_offense_home_14"];
															 for(var s in excludes) {
																 var c = this.getComponent(excludes[s]);
																 if( c !== undefined && c.isActive() ) c.onDeactivate();
															 }
														 		var clock  = this.getComponent(this.getName()+"_offense") ;
														 		if(clock !== undefined) {
																	 if(this.getMainClock().isActive()){
																		 super.startTimeAt(this.getName()+"_offense",(24*1000));
																	 } else {
																		 super.setTimeTo(this.getName()+"_offense",(24*1000));
																	 }
																 }
																 return {visible: true, type:"offense home", nonAutoStart: !this.getMainClock().isActive(),
																  team: this.state.currentGame.teamMap.HOME_TEAM,
																  message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_offense')}
													   }}
												 	 scoreboard={this}
													 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
												 	 stateName={this.getName()+"_button_offense_home_24"}
												 	 autoexpirytime="24"/>
											</div>

											<div className="col-3 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_offense_home_14_title')}
													 onInit={() => {return {}}}
													 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {
															 var excludes = [this.getName()+"_button_offense_guest_24",this.getName()+"_button_offense_guest_14",this.getName()+"_button_offense_home_24"];
															 for(var s in excludes) {
																 var c = this.getComponent(excludes[s]);
																 if( c !== undefined && c.isActive() ) c.onDeactivate();
															 }
														 		var clock  = this.getComponent(this.getName()+"_offense") ;
														 		if(clock !== undefined) {
																	 if(this.getMainClock().isActive()){
																		 super.startTimeAt(this.getName()+"_offense",(14*1000));
																	 } else {
																		 super.setTimeTo(this.getName()+"_offense",(14*1000));
																	 }
																 }
																 return {visible: true, type:"offense home",
																  nonAutoStart: !this.getMainClock().isActive(),
																  team: this.state.currentGame.teamMap.HOME_TEAM,
																  message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_offense')}
													   }}
														 scoreboard={this}
														 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
													 stateName={this.getName()+"_button_offense_home_14"}
													 autoexpirytime="10"/>
											</div>

											<div className="col-3 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_offense_guest_14_title')}
												 	 onInit={() => {return {}}}
												 	 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {
															 var excludes = [this.getName()+"_button_offense_guest_24",this.getName()+"_button_offense_home_14",this.getName()+"_button_offense_home_24"];
															 for(var s in excludes) {
																 var c = this.getComponent(excludes[s]);
																 if( c !== undefined && c.isActive() ) c.onDeactivate();
															 }
														 		var clock  = this.getComponent(this.getName()+"_offense") ;
														 		if(clock !== undefined) {
																	 if(this.getMainClock().isActive()){
																		 super.startTimeAt(this.getName()+"_offense",(14*1000));
																	 } else {
																		 super.setTimeTo(this.getName()+"_offense",(14*1000));
																	 }
																 }
																 return {visible: true, type:"offense guest",
																  nonAutoStart: !this.getMainClock().isActive(),
																  team: this.state.currentGame.teamMap.HOME_TEAM,
																  message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_offense')}
													   }}
												 		 scoreboard={this}
												 		 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
												 	 stateName={this.getName()+"_button_offense_guest_14"}
												 	 autoexpirytime="10"/>
											</div>

											<div className="col-3 p-1">
													<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_offense_guest_24_title')}
													 onInit={() => {return {}}}
													 onDeactivate={() => {return {visible: false}}}
													 onActivate={() => {
																var excludes = [this.getName()+"_button_offense_guest_14",this.getName()+"_button_offense_home_14",this.getName()+"_button_offense_home_24"];
																for(var s in excludes) {
																	var c = this.getComponent(excludes[s]);
																	if( c !== undefined && c.isActive() ) c.onDeactivate();
																}
														 		var clock  = this.getComponent(this.getName()+"_offense") ;
														 		if(clock !== undefined) {
																	 if(this.getMainClock().isActive()){
																		 super.startTimeAt(this.getName()+"_offense",(24*1000));
																	 } else {
																		 super.setTimeTo(this.getName()+"_offense",(24*1000));
																	 }
																 }
																 return {visible: true, type:"offense guest",
																  nonAutoStart: !this.getMainClock().isActive(),
																  team: this.state.currentGame.teamMap.HOME_TEAM,
																  message: _GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_message_offense')}
													   }}
														 scoreboard={this}
														 getTime={()=>this.getCurrentMainTime()} getGameId={()=>this.getCurrentGameId()}
													 stateName={this.getName()+"_button_offense_guest_24"}
													 autoexpirytime="10"/>
											</div>

</div>

									</div></div>


									<div className="row"><div className="col-12"><ScoreboardFreeTextPanel scoreboard={this} credits={true}/></div></div>
									<div className="row"><div className="col-12" style={{height:"300px",overflowY: "scroll"}}>
											<GpyGameLog stateName="gamelog" scoreboard={this} game={this.state.currentGame} onLoad={ (log) => {}}/>
									</div></div>

						 </div>
						 <div className="col-sm col-md col-lg col-xl">
						 			<div className="row">
											<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">

												<ScoreboardPeriods scoreboard={this} periodCount={4}
												onActivate={(idx)=>{
													if(this.state.components[this.getName()+"_score_home"]!==undefined) this.state.components[this.getName()+"_score_home"].setScore(this.state.dataStore.set[idx].home_score);
													if(this.state.components[this.getName()+"_score_guest"]!==undefined) this.state.components[this.getName()+"_score_guest"].setScore(this.state.dataStore.set[idx].guest_score);
												}}
												getUpdateDependenciesComponents={()=>{
													return [
														this.getName() + "_button_vs_and_score_full",
														this.getName() + "_button_vs_and_score_mini",
														this.getName() + "_button_full_statistics"
													];
												}}
												/>
												<ScoreboardTeamDefaultButtons scoreboard={this}
												needPeriodIndex={true}
												onFullScreenScore={(res)=>{
													res.homeSetWin1  = _GPY.null2Empty(this.state.dataStore.set[1].home_score);
													res.guestSetWin1 = _GPY.null2Empty(this.state.dataStore.set[1].guest_score);
													res.homeSetWin2  = _GPY.null2Empty(this.state.dataStore.set[2].home_score);
													res.guestSetWin2 = _GPY.null2Empty(this.state.dataStore.set[2].guest_score);
													res.homeSetWin3  = _GPY.null2Empty(this.state.dataStore.set[3].home_score);
													res.guestSetWin3 = _GPY.null2Empty(this.state.dataStore.set[3].guest_score);
													res.homeSetWin4  = _GPY.null2Empty(this.state.dataStore.set[4].home_score);
													res.guestSetWin4 = _GPY.null2Empty(this.state.dataStore.set[4].guest_score);

													res.sumHomePoints  =  this.getCurrentHomeScore();
													res.sumGuestPoints  =  this.getCurrentGuestScore();

													res.scoreHome  = this.state.dataStore.set[this.state.currentPeriodIndex].home_score;
													res.scoreGuest = this.state.dataStore.set[this.state.currentPeriodIndex].guest_score

													return res;
												}}
												onMiniScore={(res)=>{
													res.scoreHome  = this.state.dataStore.set[this.state.currentPeriodIndex].home_score;
													res.scoreGuest = this.state.dataStore.set[this.state.currentPeriodIndex].guest_score;
													res.sumHomePoints  =  this.getCurrentHomeScore();
													res.sumGuestPoints  =  this.getCurrentGuestScore();

													return res;
												}}
                        getOnDeactiveSmallDependenciesComponents={()=>{
													return [
														this.getName() + "_button_show_period",
														this.getName() + "_button_offense_guest_14",
														this.getName() + "_button_offense_guest_24",
														this.getName() + "_button_offense_home_14",
														this.getName() + "_button_offense_home_24"
													];
												}}
												/>
												<ScoreboardStats scoreboard={this} needPeriodIndex={true}/>
												<ScoreboardClock scoreboard={this} startStopKeyCode=" " togglePlay={(e)=>this.togglePlay(e)} countdown={true}  defaultTimes={[{name:"05:00",time:(5*60*1000)},{name:"10:00",time:(10*60*1000)},{name:"12:00",time:(12*60*1000)}]}/>
												<ScoreboardClock scoreboard={this} startStopKeyCode="," withOverlayButton={true} clockName="countdown" countdown={true}  defaultTimes={[{name:"20:00",time:(((20*60))*1000)},{name:"15:00",time:(15*60*1000)},{name:"10:00",time:(10*60*1000)},{name:"05:00",time:(5*60*1000)}]}/>
												<ScoreboardAdvertisementTournament scoreboard={this}/>
											</div>
											<div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
															<div className="row">
																<div className="col-6">
																		<strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_home_title')}</strong>
																		<GpyTeamList scoreboard={this} exclusionRoles="HOME_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="HOME_TEAM_PLAYER" stateName={this.getName()+"_teamlist_home_player"}/>
															   </div>
																 <div className="col-6">
																		<strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_guest_title')}</strong>
																		<GpyTeamList scoreboard={this} exclusionRoles="GUEST_TEAM_SUBSTITUE" game={this.state.currentGame} vsRole="GUEST_TEAM_PLAYER" stateName={this.getName()+"_teamlist_guest_player"}/>
																 </div>
															</div>
															<div className="row">
																<div className="col-12"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_substitue_title')}</strong></div>
																<div className="col-6"><GpyTeamList scoreboard={this} color="warning" exclusionRoles="HOME_TEAM_PLAYER"  game={this.state.currentGame} vsRole="HOME_TEAM_SUBSTITUE" stateName={this.getName()+"_teamlist_home_substitue"}/></div>
																<div className="col-6"><GpyTeamList scoreboard={this} color="warning" exclusionRoles="GUEST_TEAM_PLAYER" game={this.state.currentGame} vsRole="GUEST_TEAM_SUBSTITUE" stateName={this.getName()+"Hockey_teamlist_guest_substitue"}/></div>
															</div>
															<div className="row">
																<div className="col-12"><strong>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_playerlist_coach_title')}</strong></div>
																<div className="col-6"><GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="GUEST_TEAM_COACH" game={this.state.currentGame} vsRole="HOME_TEAM_COACH" stateName={this.getName()+"_teamlist_home_coach"}/></div>
																<div className="col-6"><GpyTeamList scoreboard={this} color="secondary"  exclusionRoles="HOME_TEAM_COACH" game={this.state.currentGame} vsRole="GUEST_TEAM_COACH" stateName={this.getName()+"_teamlist_guest_coach"}/></div>
															</div>
											</div>

									</div>
						   </div>
						</div>

	 :<div>{_GPY.i18n.get('gametype_'+this.getName()+'_scoreboard_warn_message_selectgame')}</div>}
			</>
	   )
	  }

}
export default SBBasketball;
